export enum GameCenterViewType {
    BOXSCORE = 'boxscore',
    PLAYBYPLAY = 'playbyplay',
    SUMMARY = 'summary',
}

export enum GameEventTypeCode {
    FACEOFF = 502,
    HIT = 503,
    GIVEAWAY = 504,
    GOAL = 505,
    SHOT_ON_GOAL = 506,
    MISSED_SHOT = 507,
    BLOCKED_SHOT = 508,
    PENALTY = 509,
    STOPPAGE = 516,
    PERIOD_START = 520,
    PERIOD_END = 521,
    SHOOTOUT_COMPLETE = 523,
    GAME_END = 524,
    TAKEAWAY = 525,
    DELAYED_PENALTY = 535,
    FAILED_SHOT_ATTEMPT = 537,
}

export enum PenaltyTypeCode {
    PENALTY_SHOT = 'PS',
}

export enum ReasonCode {
    DEFLECTED = 'deflected',
    OTHER_BLOCK = 'other-block',
    TEAMMATE_BLOCKED = 'teammate-blocked',
}

export enum ContextLabel {
    REGULAR_SEASON = 'regular_season',
    PLAYOFFS = 'playoffs',
    LAST_5_GAMES = 'last_5_games',
    TO_DATE = 'to_date',
    FOUR_NATIONS = 'four_nations',
}
